export class SelectMultiColumnDialogData {
  ControlName: string;
  Data: any;
}
